import React from 'react';
import { observer } from "mobx-react"
import ewtStore from '../EWTStore';
import {CaretDownFilled,LockOutlined,EditFilled} from '@ant-design/icons';
import {Dropdown} from 'antd';
import { theme } from '../theme';

const RoundSelector = observer(class RoundSelector extends React.Component {
	resolveRoundID() {
		const roundID = this.props.roundID;
		const roundsSource = this.props.rounds || ewtStore.rounds;
		if (roundID && roundsSource && roundsSource[roundID]) return roundID;
		if (ewtStore.currentRoundID && ewtStore.rounds && ewtStore.rounds[ewtStore.currentRoundID]) {
			return ewtStore.currentRoundID;
		}
		return roundID || '';
	}

	render() {
		const roundsSource = this.props.rounds || ewtStore.rounds;
		const selectedRoundID = this.resolveRoundID();
		const roundIDs = roundsSource ? Object.keys(roundsSource) : [];
		const items =
			roundIDs.length === 0
				? [{ key: 'empty', label: 'No rounds', disabled: true }]
				: roundIDs.map((roundID) => ({
						key: roundID,
						label: (
							<div style={{ fontSize: 26 }} className="flexRow">
								<div style={{ width: 40 }}>
									{roundsSource[roundID].finalized && (
										<LockOutlined style={{ fontSize: 26 }} />
									)}
									{roundsSource[roundID].open &&
										!roundsSource[roundID].finalized && (
											<EditFilled style={{ fontSize: 26 }} />
										)}
								</div>
								{roundsSource[roundID].desc ||
									roundsSource[roundID].name ||
									roundID}
							</div>
						),
				  }));
		const round = selectedRoundID && roundsSource && roundsSource[selectedRoundID];
		const compact = this.props.compact;
		const fillWidth = this.props.fillWidth;

		const triggerStyle = {
			height: compact ? 38 : 45,
			borderRadius: 10,
			marginTop: compact ? 0 : fillWidth ? 0 : -5,
			marginLeft: compact || fillWidth ? 0 : 5,
			fontSize: compact ? 18 : 22,
			cursor: 'pointer',
			backgroundColor: theme.surface,
			border: `1px solid ${theme.border}`,
			padding: compact ? '4px 8px' : '5px 8px',
			width: fillWidth ? '100%' : undefined,
			minWidth: fillWidth ? 0 : compact ? 160 : 200,
			maxWidth: fillWidth ? undefined : compact ? 240 : 280,
			alignItems: 'center',
			justifyContent: 'flex-start',
			color: theme.navy,
			boxShadow: theme.shadow,
		};

		return (
			<div style={{ marginTop: compact || fillWidth ? 0 : 5, width: fillWidth ? '100%' : undefined }}>
				<Dropdown
					placement="bottomLeft"
					getPopupContainer={() => document.body}
					menu={{
						items,
						onClick: ({ key }) => {
							if (key !== 'empty') this.props.handleEvent(key);
						},
						style: { width: 240 },
					}}
					trigger={['click']}
				>
					<div style={triggerStyle} className="flexRow">
						<div style={{ width: 40, flexShrink: 0, color: theme.navy }}>
							{round && round.finalized && <LockOutlined style={{ fontSize: compact ? 20 : 24 }} />}
							{round && round.open && !round.finalized && <EditFilled style={{ fontSize: compact ? 20 : 24 }} />}
						</div>
						<span style={{ flex: 1, textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: theme.navy }}>
							{round ? round.desc : 'Select round'}
						</span>
						<CaretDownFilled style={{ flexShrink: 0, marginLeft: 4, color: theme.slate }} />
					</div>
				</Dropdown>
			</div>
	  	);
	}
});


export default RoundSelector;
